import React, {useState, useEffect} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {history} from "../../../vendors/redux/store";
import {Modals} from "../../index";
import {caseSubmit, findLawyer} from "../../../vendors/actions/case";

interface OwnProps {

}

interface ConnectStateProps {
}

interface ConnectDispatchProps {
    caseSubmit: (data: any) => void,
    findLawyer: (data: any) => void
}

const contingency: any = <span>Cases offered on Contingency Basis require the attorney and the consumer
    to establish the terms of their collaboration  independently and outside of the AppearMe network.</span>;

const proBono: any = <span>
    Lawyers on our network often choose to offer their services on a Pro Bono Basis, i.e. “without charge”.
        You MUST submit explanation and supporting documents as to why you qualify for pro bono legal services to be considered.
</span>;

const CaseSubmitModal = (props: any) => {

    const {Modals: ModalActions, PriceForm} = props,
        {canSubmit} = ModalActions,
        [submitModal, setSubmit] = useState(!!canSubmit),
        [inProcess, setProcess] = useState(!!canSubmit),
        [description, setDescription] = useState(contingency);

    useEffect(() => {
        const paymentType = PriceForm.data.payment_type.value;

        if (paymentType === 'contingency') {
            setDescription(contingency)
        } else if (paymentType === 'pro_bono') {
            setDescription(proBono)
        } else {
            const other: any =
                <span>By submitting this request you agree to be charged ${calcFullPrice()}.</span>;
            setDescription(other)
        }
        return () => {
            submitModal && closeModal();
        }
    }, [PriceForm.data.payment_type.value]);


    if (!submitModal && canSubmit) {
        setSubmit(true)
    }

    const closeModal = () => {
        props.findLawyer(false);
        setSubmit(false);
        setProcess(false);
    };

    const caseSubmit = async () => {
        try {
            setProcess(true);
            const res = await props.caseSubmit(canSubmit);

            // Any refusal (a declined card answers 400_26) closes the dialog so the
            // message under the card form is visible; the case was not created.
            if (res?.type === 'CASE_SUBMIT_ERROR') {
                closeModal();
            }
        } catch (e) {
            closeModal();
            console.error(e)
        }

    };

    const calcFullPrice = () => {
        return PriceForm.data.price.coefficient ?
            (PriceForm.data.price.coefficient * PriceForm.data.price.value) : PriceForm.data.price.value
    };


    return submitModal ? (
        <Modals.Success open={submitModal}
                        className={''}
                        inProcess={inProcess}
                        cancelable={{
                            buttonTitle: 'Never Mind',
                            action: closeModal
                        }}
                        icon={'search'}
                        submit={{
                            buttonTitle: 'Find a Lawyer',
                            action: caseSubmit
                        }}
                        description={description}/>
    ) : null;
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Modals, PriceForm} = state;
    return {
        Modals,
        PriceForm,
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        caseSubmit: (data: any) => dispatch(caseSubmit(data)),
        findLawyer: (data: any) => dispatch(findLawyer(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseSubmitModal);


